import React, { useEffect, useState } from "react";
import Sidebarmenu from "../../SideMenu/Sidemenu";
import TopHeader from "../../TopHeader/TopHeader";
import "../Profile/Profile.css";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  getCountries,
  getbranch,
  updateUserDetails,
  userView,
  viewUserDetails,
} from "../../../../Helper/Redux/API";
import default_image from "../../../../img/generic1.png";
import default_image1 from "../../../../img/generic1.png";

function Profile() {
  const dispatch = useDispatch();
  const [selectcenter, setSelectCenter] = useState("");
  const [allCenter, setAllCenter] = useState("");
  const [lodingData, setLoadingData] = useState(true);
  const [loading, setLoading] = useState(false);

  const getcenterData = () => {
    dispatch(getbranch()).then((res) => {
      if (res?.payload?.status === true) {
        setAllCenter(res?.payload?.data);
      } else {
        toast.error(res?.payload?.message);
      }
    });
  };

  const getcountriData = () => {
    dispatch(getCountries()).then((res) => {
      if (res?.payload?.status === true) {
        setAllCoountries(res?.payload?.data);
        // console.log(res?.payload?.data);
      } else {
        toast.error(res?.payload?.message);
      }
    });
  };
  const [allCountries, setAllCoountries] = useState("");
  const Countries = Array.isArray(allCountries)
    ? allCountries.map((item) => ({
        label: item.title,
        value: item.id,
      }))
    : [];

  const [initialValue, setInitialValue] = useState({
    first_name: "",
    last_name: "",
    age:"",
    gender: "",
    dob: "",
    address1: "",
    address2: "",
    postal_code: "",
    nationality: "",
    nric_no: "",
    race: "",
    occupation: "",
    email: "",
    language_spoken: "",
    mobile_hp_number: "",
    home_number: "",
    office_number: "",
    family_member_name: "",
    relation_with_patient: "",
    member_number: "",
    member_hp: "",
    member_office: "",
    member_home: "",
    personal_name: "",
    personal_sign: "",
    personal_nric_pp: "",
    personal_date: "",
    onset: "",
    left: "",
    right: "",
    gradual: "",
    student: "",
    birth: "",
    other_phase_state: "",
    ear_pain: "",
    head_injury: "",
    medical_condition: "",
    discharge: "",
    surgery: "",
    current_mediation: "",
    headache: "",
    vomiting: "",
    noise_exposure: "",
    sinusitus: "",
    pain_swallowing: "",
    family_history: "",
    vertigo: "",
    fullness_of_ear: "",
    tinnitus: "",
    one_to_one: "",
    meeting: "",
    television: "",
    bg_noise: "",
    group: "",
    church: "",
    telephone: "",
    other_area_difficulty: "",
    remark: "",
    preview_img: null,
    send_media: null,
  });
  console.log(initialValue , "intialalus");
  // console.log(initialValue, "fkfghdfghdfjghdfjh");
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInitialValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const hearingcenter = Array.isArray(allCenter)
    ? allCenter.map((item) => ({
        label: item.title,
        value: item.id,
      }))
    : [];

  const handleChangecenter = (event) => {
    setSelectCenter(event.target.value); // Update the state with the selected value
  };

  const getviewuser = () => {
    setLoadingData(true);
    try {
      dispatch(viewUserDetails()).then((res) => {
        setLoadingData(false);

        if (res?.payload?.status === true) {
          console.log(res?.payload?.data?.first_name);
          setSelectCenter(res?.payload?.data?.branch_id);
          // setNationality(res?.payload?.data?.country_id);
          setInitialValue({
            first_name: res?.payload?.data?.first_name
              ? res?.payload?.data?.first_name
              : "",
            last_name: res?.payload?.data?.last_name
              ? res?.payload?.data?.last_name
              : "",
              age: res?.payload?.data?.age
              ? res?.payload?.data?.age
              : "",
            gender: res?.payload?.data?.gender
              ? res?.payload?.data?.gender
              : "",
            dob: res?.payload?.data?.dob
              ? res?.payload?.data?.dob.split(" ")[0]
              : "",
            address1: res?.payload?.data?.address_one
              ? res?.payload?.data?.address_one
              : "",
            address2: res?.payload?.data?.address_two
              ? res?.payload?.data?.address_two
              : "",
            postal_code: res?.payload?.data?.postal_code
              ? res?.payload?.data?.postal_code
              : "",
            nationality: res?.payload?.data?.country_id
              ? res?.payload?.data?.country_id
              : "",
            nric_no: res?.payload?.data?.nric_number
              ? res?.payload?.data?.nric_number
              : "",
            race: res?.payload?.data?.race_number
              ? res?.payload?.data?.race_number
              : "",
            occupation: res?.payload?.data?.occupation
              ? res?.payload?.data?.occupation
              : "",
            email: res?.payload?.data?.email ? res?.payload?.data?.email : "",
            language_spoken: res?.payload?.data?.contact_lang
              ? res?.payload?.data?.contact_lang
              : "",
            mobile_hp_number: res?.payload?.data?.mobile_number
              ? res?.payload?.data?.mobile_number
              : "",
            home_number: res?.payload?.data?.home_number
              ? res?.payload?.data?.home_number
              : "",
            office_number: res?.payload?.data?.contact_office_no
              ? res?.payload?.data?.contact_office_no
              : "",
            family_member_name: res?.payload?.data?.family_member_name
              ? res?.payload?.data?.family_member_name
              : "",
            relation_with_patient: res?.payload?.data?.family_member_relation
              ? res?.payload?.data?.family_member_relation
              : "",
            member_number: res?.payload?.data?.family_member_contact_no
              ? res?.payload?.data?.family_member_contact_no
              : "",
            member_hp: res?.payload?.data?.family_member_hp
              ? res?.payload?.data?.family_member_hp
              : "",
            member_office: res?.payload?.data?.member_office
              ? res?.payload?.data?.member_office
              : "",
            member_home: res?.payload?.data?.member_home
              ? res?.payload?.data?.member_home
              : "",
            personal_name: res?.payload?.data?.personal_name
              ? res?.payload?.data?.personal_name
              : "",
            personal_sign: res?.payload?.data?.personal_sign
              ? res?.payload?.data?.personal_sign
              : "",
            personal_nric_pp: res?.payload?.data?.personal_nric_pp
              ? res?.payload?.data?.personal_nric_pp
              : "",
            personal_date: res?.payload?.data?.personal_date
              ? res?.payload?.data?.personal_date
              : "",
            onset: res?.payload?.data?.onset ? res?.payload?.data?.onset : "",
            left: res?.payload?.data?.left ? res?.payload?.data?.left : "",
            right: res?.payload?.data?.right ? res?.payload?.data?.right : "",
            gradual: res?.payload?.data?.gradual
              ? res?.payload?.data?.gradual
              : "",
            student: res?.payload?.data?.student
              ? res?.payload?.data?.student
              : "",
            birth: res?.payload?.data?.birth ? res?.payload?.data?.birth : "",
            other_phase_state: res?.payload?.data?.other_phase_state
              ? res?.payload?.data?.other_phase_state
              : "",
            ear_pain: res?.payload?.data?.ear_pain
              ? res?.payload?.data?.ear_pain
              : "",
            head_injury: res?.payload?.data?.head_injury
              ? res?.payload?.data?.head_injury
              : "",
            medical_condition: res?.payload?.data?.medical_condition
              ? res?.payload?.data?.medical_condition
              : "",
            discharge: res?.payload?.data?.discharge
              ? res?.payload?.data?.discharge
              : "",
            surgery: res?.payload?.data?.surgery
              ? res?.payload?.data?.surgery
              : "",
            current_mediation: res?.payload?.data?.current_medication
              ? res?.payload?.data?.current_medication
              : "",
            headache: res?.payload?.data?.headache
              ? res?.payload?.data?.headache
              : "",
            vomiting: res?.payload?.data?.vomating
              ? res?.payload?.data?.vomating
              : "",
            noise_exposure: res?.payload?.data?.noise_exposure
              ? res?.payload?.data?.noise_exposure
              : "",
            sinusitus: res?.payload?.data?.sinusitus
              ? res?.payload?.data?.sinusitus
              : "",
            pain_swallowing: res?.payload?.data?.pain_swallowing
              ? res?.payload?.data?.pain_swallowing
              : "",
            family_history: res?.payload?.data?.family_history
              ? res?.payload?.data?.family_history
              : "",
            vertigo: res?.payload?.data?.vertigo
              ? res?.payload?.data?.vertigo
              : "",
            fullness_of_ear: res?.payload?.data?.fullness_of_ear
              ? res?.payload?.data?.fullness_of_ear
              : "",
            tinnitus: res?.payload?.data?.tinnitus
              ? res?.payload?.data?.tinnitus
              : "",
            one_to_one: res?.payload?.data?.one_to_one
              ? res?.payload?.data?.one_to_one
              : "",
            meeting: res?.payload?.data?.meeting
              ? res?.payload?.data?.meeting
              : "",
            television: res?.payload?.data?.television
              ? res?.payload?.data?.television
              : "",
            bg_noise: res?.payload?.data?.background_noise
              ? res?.payload?.data?.background_noise
              : "",
            group: res?.payload?.data?.group
              ? res?.payload?.data?.background_noise
              : "",
            church: res?.payload?.data?.church
              ? res?.payload?.data?.church
              : "",
            telephone: res?.payload?.data?.telephone
              ? res?.payload?.data?.telephone
              : "",
            other_area_difficulty: res?.payload?.data?.other
              ? res?.payload?.data?.other
              : "",
            remark: res?.payload?.data?.remarks
              ? res?.payload?.data?.remarks
              : "",
            preview_img: res?.payload?.data?.profile_image,
            send_media: res?.payload?.data?.profile_image
              ? res?.payload?.data?.profile_image
              : "",
          });
        }
      });
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    // getcountriData();
    getviewuser();
    getcenterData();
    getcountriData();
  }, []);

  const handleChangeImage = (e) => {
    let file = e.target.files[0];
    setInitialValue((prev) => ({
      ...prev,
      preview_img: URL.createObjectURL(file),
      send_media: file,
    }));
  };

  const updateData = () => {
    let profileFormData = new FormData();
    localStorage.setItem("UserName", initialValue.first_name);
    localStorage.setItem("lastName", initialValue.last_name);

    profileFormData.append("branch_id", selectcenter ? selectcenter : null);

    profileFormData.append(
      "first_name",
      initialValue.first_name ? initialValue.first_name : ""
    );
    profileFormData.append(
      "last_name",
      initialValue.last_name ? initialValue.last_name : ""
    );
    profileFormData.append(
      "postal_code",
      initialValue.postal_code ? initialValue.postal_code : ""
    );
    profileFormData.append(
      "age",
      initialValue.age ? initialValue.age : ""
    );
    profileFormData.append(
      "gender",
      initialValue.gender ? initialValue.gender : ""
    );
    profileFormData.append("dob", initialValue.dob ? initialValue.dob : "");
    profileFormData.append("address_one", initialValue.address1 ? initialValue.address1 : "");

    profileFormData.append("address_two", initialValue.address2 ? initialValue.address2 : "");

    profileFormData.append("country_id", initialValue.nationality ? initialValue.nationality : "");

    // profileFormData.append("nationality", nationality ? nationality : null);
    profileFormData.append(
      "nric_number",
      initialValue.nric_no ? initialValue.nric_no : ""
    );
    profileFormData.append(
      "race_number",
      initialValue.race ? initialValue.race : ""
    );
    profileFormData.append(
      "occupation",
      initialValue.occupation ? initialValue.occupation : ""
    );
    profileFormData.append(
      "email",
      initialValue.email ? initialValue.email : ""
    );
    profileFormData.append(
      "contact_lang",
      initialValue.language_spoken ? initialValue.language_spoken : ""
    );
    profileFormData.append(
      "mobile_number",
      initialValue.mobile_hp_number ? initialValue.mobile_hp_number : ""
    );
    profileFormData.append(
      "home_number",
      initialValue.home_number ? initialValue.home_number : ""
    );
    profileFormData.append(
      "contact_office_no",
      initialValue.office_number ? initialValue.office_number : ""
    );
    profileFormData.append(
      "family_member_name",
      initialValue.family_member_name ? initialValue.family_member_name : ""
    );
    profileFormData.append(
      "family_member_relation",
      initialValue.relation_with_patient
        ? initialValue.relation_with_patient
        : ""
    );
    profileFormData.append(
      "family_member_contact_no",
      initialValue.member_number ? initialValue.member_number : ""
    );
    profileFormData.append(
      "family_member_hp",
      initialValue.member_hp ? initialValue.member_hp : ""
    );
    profileFormData.append(
      "member_office",
      initialValue.member_office ? initialValue.member_office : ""
    );
    profileFormData.append(
      "member_home",
      initialValue.member_office ? initialValue.member_office : ""
    );
    profileFormData.append(
      "personal_name",
      initialValue.personal_name ? initialValue.personal_name : ""
    );
    profileFormData.append(
      "personal_sign",
      initialValue.personal_sign ? initialValue.personal_sign : ""
    );
    profileFormData.append(
      "personal_nric_pp",
      initialValue.personal_nric_pp ? initialValue.personal_nric_pp : ""
    );
    profileFormData.append(
      "personal_date",
      initialValue.personal_date ? initialValue.personal_date : ""
    );
    profileFormData.append(
      "onset",
      initialValue.onset ? initialValue.onset : ""
    );
    profileFormData.append("left", initialValue.left ? initialValue.left : "");
    profileFormData.append(
      "right",
      initialValue.right ? initialValue.right : ""
    );
    profileFormData.append(
      "gradual",
      initialValue.gradual ? initialValue.gradual : ""
    );
    profileFormData.append(
      "student",
      initialValue.student ? initialValue.student : ""
    );
    profileFormData.append(
      "birth",
      initialValue.birth ? initialValue.birth : ""
    );
    profileFormData.append(
      "other_phase_state",
      initialValue.other_phase_state ? initialValue.other_phase_state : ""
    );
    profileFormData.append(
      "ear_pain",
      initialValue.ear_pain ? initialValue.ear_pain : ""
    );
    profileFormData.append(
      "head_injury",
      initialValue.head_injury ? initialValue.head_injury : ""
    );
    profileFormData.append(
      "medical_condition",
      initialValue.medical_condition ? initialValue.medical_condition : ""
    );
    profileFormData.append(
      "discharge",
      initialValue.discharge ? initialValue.discharge : ""
    );
    profileFormData.append(
      "surgery",
      initialValue.surgery ? initialValue.surgery : ""
    );
    profileFormData.append(
      "current_mediation",
      initialValue.current_mediation ? initialValue.current_mediation : ""
    );
    profileFormData.append(
      "headache",
      initialValue.headache ? initialValue.headache : ""
    );
    profileFormData.append(
      "vomating",
      initialValue.vomiting ? initialValue.vomiting : ""
    );
    profileFormData.append(
      "noise_exposure",
      initialValue.noise_exposure ? initialValue.noise_exposure : ""
    );
    profileFormData.append(
      "sinusitus",
      initialValue.sinusitus ? initialValue.sinusitus : ""
    );
    profileFormData.append(
      "pain_swallowing",
      initialValue.pain_swallowing ? initialValue.pain_swallowing : ""
    );
    profileFormData.append(
      "family_history",
      initialValue.family_history ? initialValue.family_history : ""
    );
    profileFormData.append(
      "vertigo",
      initialValue.vertigo ? initialValue.vertigo : ""
    );
    profileFormData.append(
      "fullness_of_ear",
      initialValue.fullness_of_ear ? initialValue.fullness_of_ear : ""
    );
    profileFormData.append(
      "tinnitus",
      initialValue.tinnitus ? initialValue.tinnitus : ""
    );
    profileFormData.append(
      "one_to_one",
      initialValue.one_to_one ? initialValue.one_to_one : ""
    );
    profileFormData.append(
      "meeting",
      initialValue.meeting ? initialValue.meeting : ""
    );
    profileFormData.append(
      "television",
      initialValue.television ? initialValue.television : ""
    );
    profileFormData.append(
      "background_noise",
      initialValue.bg_noise ? initialValue.bg_noise : ""
    );
    profileFormData.append(
      "group",
      initialValue.group ? initialValue.group : ""
    );
    profileFormData.append(
      "church",
      initialValue.church ? initialValue.church : ""
    );
    profileFormData.append(
      "other",
      initialValue.other_area_difficulty
        ? initialValue.other_area_difficulty
        : ""
    );
    profileFormData.append(
      "remarks",
      initialValue.remark ? initialValue.remark : ""
    );
    profileFormData.append(
      "telephone",
      initialValue.telephone ? initialValue.telephone : ""
    );
    profileFormData.append(
      "profile_image",
      initialValue.send_media ? initialValue.send_media : ""
    );
    setLoading(true);
    let requestOptions = {
      method: "POST",
      body: profileFormData,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`, // Include the authorization token
      },
    };
    try {
      dispatch(updateUserDetails(requestOptions)).then((res) => {
        setLoading(false);

        if (res?.payload?.status === true) {
          toast.success(res?.payload?.message);
        } else {
          toast.error(res?.payload?.message);
        }
      });
    } catch (error) {
      console.log(`error ${error}`);
    }
  };

  // const [nationality, setNationality] = useState("");

  // const handleChangenationality = (event) => {
  //   setNationality(event.target.value); // Update the state with the selected value
  // };

  const [today, setToday] = useState("");
  useEffect(() => {
    const todayDate = new Date().toISOString().split("T")[0];
    setToday(todayDate);
  }, []);

  return (
    <>
      <div
        className="side_div_menu"
        style={{ display: "flex", height: "100%" }}
      >
        <Sidebarmenu />
        <section className="Home_page allsection">
          <TopHeader heding_text="Profile" />
          <div className="container-fluid">
            {/* {!lodingData && ( */}
            <div className="Myhistory">
              <div class="row historyform">
                <div className="user_progile_container">
                  <div className="profile_img_container ">
                    <img
                      src={
                        initialValue?.preview_img
                          ? initialValue?.preview_img
                          : default_image
                      }
                      alt=""
                      className="preview_profile_image"
                    />

                    <button className="upload_image_btn">
                      Update profile image
                    </button>
                    <input
                      type="file"
                      accept=".jpg , .jpeg , .png"
                      onChange={handleChangeImage}
                      className="profile_upload_input"
                    />
                  </div>
                </div>
                {/* <div class="col-md-12">
                  <label for="inputState" class="form-label">
                    Select Center
                  </label>
                  <select
                    className="form-select"
                    id="floatingSelect"
                    aria-label="Floating label select example"
                    value={selectcenter}
                    onChange={handleChangecenter}
                  >
                   
                    {hearingcenter.map((country) => (
                      <option key={country.value} value={country.value}>
                        {country.label}
                      </option>
                    ))}
                  </select>
                </div> */}
                <div class="col-md-6">
                  <label for="inputEmail4" class="form-label">
                    First Name
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputEmail4"
                    placeholder="First Name"
                    name="first_name"
                    onChange={handleChange}
                    value={initialValue?.first_name}
                  />
                </div>
                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    Last Name
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="Last Name"
                    name="last_name"
                    onChange={handleChange}
                    value={initialValue?.last_name}
                  />
                </div>
                <div class="col-md-6">
                  <label for="age" class="form-label">
                    Age
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="age"
                    placeholder="Age"
                    name="age"
                    onChange={handleChange}
                    value={initialValue?.age}
                  />
                </div>
                <div class="col-md-6">
                  <label for="inputState" class="form-label">
                    Gender
                  </label>
                  <select
                    id="inputState"
                    class="form-select"
                    name="gender"
                    value={initialValue?.gender}
                    onChange={handleChange}
                  >
                    <option value="">Gender</option>

                    <option value="1">Male</option>
                    <option value="2">Female</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label for="inputState" class="form-label">
                    Date of Birth
                  </label>
                  <input
                    type="date"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="Date of Birth"
                    name="dob"
                    max={today}
                    onChange={handleChange}
                    value={initialValue?.dob}
                  />
                </div>
                <div class="col-md-6">
                  <label for="inputAddress1" class="form-label">
                    Address 1
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputAddress1"
                    placeholder="Address 1"
                    name="address1"
                    onChange={handleChange}
                    value={initialValue?.address1}
                  />
                </div>
                <div class="col-md-6">
                  <label for="inputAddress2" class="form-label">
                    Address 2
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputAddress2"
                    placeholder="Address 2"
                    name="address2"
                    onChange={handleChange}
                    value={initialValue?.address2}
                  />
                </div>
                <div class="col-md-6">
                  <label for="inputEmail4" class="form-label">
                    Postal code
                  </label>
                  <input
                    type="number"
                    class="form-control"
                    id="inputEmail4"
                    placeholder="Postal Code"
                    name="postal_code"
                    onChange={handleChange}
                    value={initialValue?.postal_code}
                  />
                </div>
                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    Nationality
                  </label>
                  <select
                    className="form-select"
                    name="nationality"
                    id="floatingSelect"
                    aria-label="Floating label select example"
                    value={initialValue?.nationality}
                    onChange={handleChange}
                  >
                    {/* <option selected>Select Center</option> */}
                    {Countries.map((country) => (
                      <option key={country.value} value={country.value}>
                        {country.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div class="col-md-6">
                  <label for="inputEmail4" class="form-label">
                    NRIC NUMBER
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputEmail4"
                    placeholder="NRIC NO."
                    name="nric_no"
                    onChange={handleChange}
                    value={initialValue?.nric_no}
                  />
                </div>
                {/* <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    Race Number
                  </label>
                  <input
                    type="number"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="Race"
                    name="race"
                    onChange={handleChange}
                    value={initialValue?.race}
                  />
                </div> */}

                {/* <div class="col-md-6">
                  <label for="inputEmail4" class="form-label">
                    Occupation
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputEmail4"
                    placeholder="Occupation"
                    name="occupation"
                    onChange={handleChange}
                    value={initialValue?.occupation}
                  />
                </div> */}
                <div class="col-md-6">
                  <label for="inputEmail4" class="form-label">
                    Mobile/HP Number
                  </label>
                  <input
                    type="number"
                    class="form-control"
                    id="inputEmail4"
                    placeholder="Mobile/HP Number"
                    name="mobile_hp_number"
                    onChange={handleChange}
                    value={initialValue?.mobile_hp_number}
                  />
                </div>
                <div class="col-md-6">
                  <label for="inputHome" class="form-label">
                    Home Number
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputHome"
                    placeholder="Home Number"
                    name="home_number"
                    onChange={handleChange}
                    value={initialValue?.home_number}
                  />
                </div>
                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    Email address
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="Email Address"
                    name="email"
                    onChange={handleChange}
                    value={initialValue?.email}
                    disabled
                  />
                </div>



                {/* <h6 className="info_text">Contact information</h6>
                <div class="col-md-6">
                  <label for="inputState" class="form-label">
                    Language Spoken
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputEmail4"
                    placeholder=" Language Spoken"
                    name="language_spoken"
                    onChange={handleChange}
                    value={initialValue?.language_spoken}
                  />
                </div>
                <div class="col-md-6">
                  <label for="inputEmail4" class="form-label">
                    Mobile/HP Number
                  </label>
                  <input
                    type="number"
                    class="form-control"
                    id="inputEmail4"
                    placeholder="Mobile/HP Number"
                    name="mobile_hp_number"
                    onChange={handleChange}
                    value={initialValue?.mobile_hp_number}
                  />
                </div>

                <div class="col-md-6">
                  <label for="inputEmail4" class="form-label">
                    Home Number
                  </label>
                  <input
                    type="number"
                    class="form-control"
                    id="inputEmail4"
                    placeholder="Home Number"
                    name="home_number"
                    onChange={handleChange}
                    value={initialValue?.home_number}
                  />
                </div>
                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    Office Number
                  </label>
                  <input
                    type="number"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="Office Number"
                    name="office_number"
                    onChange={handleChange}
                    value={initialValue?.office_number}
                  />
                </div> */}

                {/* <h6 className="info_text">Other Family Members To Contact</h6>
                <div class="col-md-6">
                  <label for="inputEmail4" class="form-label">
                    Name
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputEmail4"
                    placeholder="Name"
                    name="family_member_name"
                    onChange={handleChange}
                    value={initialValue?.family_member_name}
                  />
                </div>
                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    Relationship to Patient
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="Relationship to Patient"
                    name="relation_with_patient"
                    onChange={handleChange}
                    value={initialValue?.relation_with_patient}
                  />
                </div>

                <div class="col-md-6">
                  <label for="inputEmail4" class="form-label">
                    Contact Number
                  </label>
                  <input
                    type="number"
                    class="form-control"
                    id="inputEmail4"
                    placeholder="Contact Number"
                    name="member_number"
                    onChange={handleChange}
                    value={initialValue?.member_number}
                  />
                </div>
                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    HP
                  </label>
                  <input
                    type="number"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="HP"
                    name="member_hp"
                    onChange={handleChange}
                    value={initialValue?.member_hp}
                  />
                </div>

                <div class="col-md-6">
                  <label for="inputEmail4" class="form-label">
                    Office
                  </label>
                  <input
                    type="number"
                    class="form-control"
                    id="inputEmail4"
                    placeholder="Office"
                    name="member_home"
                    onChange={handleChange}
                    value={initialValue?.member_home}
                  />
                </div>
                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    Home
                  </label>
                  <input
                    type="number"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="Home"
                    name="member_office"
                    onChange={handleChange}
                    value={initialValue?.member_office}
                  />
                </div> */}

                {/* <h6 className="info_text">
                    Personal Data Consent Declaration
                  </h6>
                  <p className="info_peregrap">
                    By Providing the Information set out in this form, I agree
                    and Consent to <span> The Hearing Center PTE. LTD.</span>
                  </p>

                  <div class="col-md-6">
                    <label for="inputState" class="form-label">
                      Name
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="inputEmail4"
                      placeholder="Name"
                      name="personal_name"
                      onChange={handleChange}
                      value={initialValue?.personal_name}
                    />
                  </div>
                  <div class="col-md-6">
                    <label for="inputEmail4" class="form-label">
                      Add Signature
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="inputEmail4"
                      placeholder="Add Signature"
                      name="personal_sign"
                      onChange={handleChange}
                      value={initialValue?.personal_sign}
                    />
                  </div>

                  <div class="col-md-6">
                    <label for="inputEmail4" class="form-label">
                      NRIC/PP
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="inputEmail4"
                      placeholder="NRIC/PP"
                      name="personal_nric_pp"
                      onChange={handleChange}
                      value={initialValue?.personal_nric_pp}
                    />
                  </div>
                  <div class="col-md-6">
                    <label for="inputPassword4" class="form-label">
                      Date
                    </label>
                    <input
                      type="date"
                      class="form-control"
                      id="inputPassword4"
                      placeholder="Date"
                      name="personal_date"
                      onChange={handleChange}
                      value={initialValue?.personal_date}
                    />
                  </div> */}
                


                {/* <h6 className="info_text">For Office USE</h6>
                <p className="info_peregrap">
                  Referral Source: From where did you find out about
                  <span>The Hearing Centre?</span>
                </p> */}


                {/* 
                <div class="col-md-12">
                  <label for="inputState" class="form-label">
                    Please State
                  </label>
                  <Select
                    defaultValue={selectedOption}
                    onChange={setSelectedOption}
                    options={options}
                  />
                </div> */}

                {/* <h6 className="info_text">Complaint Of</h6>

                <div class="col-md-12">
                  <label for="inputState" class="form-label">
                    Onset
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputEmail4"
                    placeholder="Onset"
                    name="onset"
                    onChange={handleChange}
                    value={initialValue?.onset}
                  />
                </div>
                <div class="col-md-6">
                  <label for="inputEmail4" class="form-label">
                    R
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputEmail4"
                    placeholder="R"
                    name="right"
                    onChange={handleChange}
                    value={initialValue?.right}
                  />
                </div>

                <div class="col-md-6">
                  <label for="inputEmail4" class="form-label">
                    L
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputEmail4"
                    placeholder="l"
                    name="left"
                    onChange={handleChange}
                    value={initialValue?.left}
                  />
                </div>
                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    Gradual
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="Gradual"
                    name="gradual"
                    onChange={handleChange}
                    value={initialValue?.gradual}
                  />
                </div>
                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    Student
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="Student"
                    onChange={handleChange}
                    name="student"
                    value={initialValue?.student}
                  />
                </div>

                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    Birth
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="Birth"
                    name="birth"
                    onChange={handleChange}
                    value={initialValue?.birth}
                  />
                </div>
                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    Other(Phase State)
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="Other(Phase State)"
                    name="other_phase_state"
                    onChange={handleChange}
                    value={initialValue?.other_phase_state}
                  />
                </div>

                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    Ear Pain
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="Ear Pain"
                    name="ear_pain"
                    onChange={handleChange}
                    value={initialValue?.ear_pain}
                  />
                </div>
                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    Head Injury
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="Head Injury"
                    name="head_injury"
                    onChange={handleChange}
                    value={initialValue?.head_injury}
                  />
                </div>

                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    medical condition
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="medical condition"
                    name="medical_condition"
                    onChange={handleChange}
                    value={initialValue?.medical_condition}
                  />
                </div>
                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    discharge
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="discharge"
                    name="discharge"
                    onChange={handleChange}
                    value={initialValue?.discharge}
                  />
                </div>

                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    surgery
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="surgery "
                    name="surgery"
                    onChange={handleChange}
                    value={initialValue?.surgery}
                  />
                </div>
                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    current medication
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="current medication"
                    name="current_mediation"
                    onChange={handleChange}
                    value={initialValue?.current_mediation}
                  />
                </div>

                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    headache
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="headache"
                    name="headache"
                    onChange={handleChange}
                    value={initialValue?.headache}
                  />
                </div>
                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    vomiting
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="vomiting"
                    name="vomiting"
                    onChange={handleChange}
                    value={initialValue?.vomiting}
                  />
                </div>

                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    nosie exposure.
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="nosie exposure. "
                    name="noise_exposure"
                    onChange={handleChange}
                    value={initialValue?.noise_exposure}
                  />
                </div>
                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    sinusitus
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="sinusitus"
                    name="sinusitus"
                    onChange={handleChange}
                    value={initialValue?.sinusitus}
                  />
                </div>

                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    pain swallowing
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="pain swallowing"
                    name="pain_swallowing"
                    onChange={handleChange}
                    value={initialValue?.pain_swallowing}
                  />
                </div>
                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    family history
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="family history"
                    name="family_history"
                    onChange={handleChange}
                    value={initialValue?.family_history}
                  />
                </div>

                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    vertigo
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="vertigo"
                    name="vertigo"
                    onChange={handleChange}
                    value={initialValue?.vertigo}
                  />
                </div>
                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    fullness of ear
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="fullness of ear"
                    name="fullness_of_ear"
                    onChange={handleChange}
                    value={initialValue?.fullness_of_ear}
                  />
                </div>

                <div class="col-md-12">
                  <label for="inputPassword4" class="form-label">
                    tinnitus
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="tinnitus"
                    name="tinnitus"
                    onChange={handleChange}
                    value={initialValue?.tinnitus}
                  />
                </div>

                <h6 className="info_text">Area of Difficulty</h6>

                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    1 to 10
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="1 to 10"
                    name="one_to_one"
                    onChange={handleChange}
                    value={initialValue?.one_to_one}
                  />
                </div>
                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    meeting
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="meeting"
                    name="meeting"
                    onChange={handleChange}
                    value={initialValue?.meeting}
                  />
                </div>

                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    television
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="television"
                    name="television"
                    onChange={handleChange}
                    value={initialValue?.television}
                  />
                </div>
                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    background noise
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="background noise"
                    name="bg_noise"
                    onChange={handleChange}
                    value={initialValue?.bg_noise}
                  />
                </div>

                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    group
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="group"
                    name="group"
                    onChange={handleChange}
                    value={initialValue?.group}
                  />
                </div>
                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    church
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="church"
                    name="church"
                    onChange={handleChange}
                    value={initialValue?.church}
                  />
                </div>

                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    telephone
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="telephone"
                    name="telephone"
                    onChange={handleChange}
                    value={initialValue?.telephone}
                  />
                </div>
                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label">
                    other
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="other"
                    name="other_area_difficulty"
                    onChange={handleChange}
                    value={initialValue?.other_area_difficulty}
                  />
                </div>

                <div class="col-md-12">
                  <label for="inputPassword4" class="form-label">
                    remarks
                  </label>
                  <textarea
                    class="form-control"
                    placeholder="Leave a comment here"
                    id="floatingTextarea2"
                    rows="6"
                    name="remark"
                    onChange={handleChange}
                    value={initialValue?.remark}
                  ></textarea>
                </div> */}

                {/* <div class="col-12">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="gridCheck"
                    />
                    <label class="form-check-label" for="gridCheck">
                      Check me out
                    </label>
                  </div>
                </div> */}
                <div className="">
                  <button
                    className="update_profile_btn"
                    onClick={() => updateData()}
                    disabled={loading === true}
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Profile;
